import { Link } from "react-router-dom";
import { usePageMetadata } from "../lib/metadata";

export function NotFoundPage() {
  usePageMetadata({ title: "Page not found — Emails Unsubscriber", description: "The requested Emails Unsubscriber page does not exist." });
  return (
    <section className="unsub-page-state">
      <div className="unsub-page-state-mark" aria-hidden="true">404</div>
      <h1>That page is not in this inbox.</h1>
      <p>The link may be old, or the page may have moved.</p>
      <Link className="unsub-button" to="/">Return home</Link>
    </section>
  );
}
